import { Locales } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { createPushToken } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useCreatePushTokenMutation = () =>
  useMutation({
    mutationFn: async ({
      userId,
      token,
      locale,
    }: {
      userId: ID;
      token: string;
      locale: Locales;
    }) => createPushToken(userId, token, locale),
  });
